import { render, staticRenderFns } from "./qwik_printsticker.vue?vue&type=template&id=a39f6336&"
import script from "./qwik_printsticker.vue?vue&type=script&lang=js&"
export * from "./qwik_printsticker.vue?vue&type=script&lang=js&"
import style0 from "./qwik_printsticker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports